import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=5bdb504b&scoped=true&"
import script from "./CourseList.vue?vue&type=script&lang=js&"
export * from "./CourseList.vue?vue&type=script&lang=js&"
import style1 from "./CourseList.vue?vue&type=style&index=1&id=5bdb504b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb504b",
  null
  
)

export default component.exports